import React, {Component} from 'react';
import {gpn} from "../GPN"
import config from "../config";
import req from "../req";
import Back from "../sections/Back";
import Button from "../sections/MUI/Button";
import Modal from "../sections/MUI/Modal";
import Field from "../sections/MUI/Field";
import {toast} from "react-toastify";
import Icon from "../sections/MUI/Icon";

class Services extends Component {

    state = {
        services: [],

        title: "",
        price: "",


        editIndex: -1,
        modalAdd: false
    };

    componentDidMount() {
        config.scrollTop();
        this.getServices();
    }


    getServices() {
        req.get(`/service`)
            .then(r => {
                if (r) {
                    this.setState({services: r});
                }
            });
    }

    submit() {
        let {title, price} = this.state;
        title = config.getStringValue(title, "");
        price = config.getStringValue(price, "");
        price = price.replace(/,/g, "").toString().trim();
        if (title !== "") {
            toast.info("در حال ثبت ...");
            req.post(`/service`, {
                title,
                price
            })
                .then(r => {
                    toast.success("با موفقیت ثبت شد.");
                    this.setState({
                        title: "",
                        price: ""
                    });
                    this.getServices();
                });
        } else {
            toast.error("عنوان خدمت وارد نشده!");
        }

    }

    delete(id = "") {
        toast.info("در حال حذف ...")
        req.delete(`/service?id=${id}`)
            .then(r => {
                toast.success("با موفقیت حذف شد.");
                this.getServices();
            });
    }

    handleInputChange(name, value) {
        let {services, editIndex} = this.state;
        services[editIndex][name] = value;
        this.setState({services});
    }

    edit() {
        let {services, editIndex} = this.state;
        const {id, title, price} = services[editIndex];

        toast.info("در حال ویرایش ...");
        req.put(`/service`, {
            id,
            title: title.toString().trim(),
            price: price.replace(/,/g, "").trim()
        })
            .then(r => {
                toast.success("با موفقیت ویرایش شد.");
                this.setState({
                    editIndex: -1
                });
                this.getServices();
            });
    }

    render() {
        let {
            services,
            title, price,
            modalAdd,
            editIndex
        } = this.state;
        return (
            <div className="services">
                {
                    editIndex !== -1 ?
                        <Modal display={editIndex !== -1}
                               title="ویرایش خدمت"
                               onCloseClick={() => this.setState({editIndex: -1})}>
                            <Field name="title"
                                   value={services[editIndex].title}
                                   maxLength={500}
                                   label="عنوان خدمت"
                                   onChange={(name, value) => this.handleInputChange(name, value)}/>
                            <Field name="price"
                                   value={services[editIndex].price}
                                   typePrice
                                   maxLength={20}
                                   style={{direction: "ltr"}}
                                   label="نرخ خدمت (تومان)"
                                   onChange={(name, value) => this.handleInputChange(name, value)}/>
                            <br/>
                            <div className="row justify-content-center">
                                <div className="col-md-5">
                                    <Button icon="check" onClick={() => this.edit()}>ویرایش کردن</Button>
                                </div>
                            </div>
                        </Modal> : null
                }
                <Modal title="ثبت خدمت"
                       display={modalAdd}
                       onCloseClick={() => this.setState({modalAdd: false})}>
                    <Field name="title"
                           value={title}
                           maxLength={500}
                           label="عنوان خدمت"
                           onChange={(name, value) => this.setState({[name]: value})}/>
                    <Field name="price"
                           value={price}
                           typePrice
                           maxLength={20}
                           style={{direction: "ltr"}}
                           label="نرخ خدمت (تومان)"
                           onChange={(name, value) => this.setState({[name]: value})}/>
                    <br/>
                    <div className="row justify-content-center">
                        <div className="col-md-5">
                            <Button icon="check" onClick={() => this.submit()}>ثبت کردن</Button>
                        </div>
                    </div>
                </Modal>
                <Back {...this.props}/>
                <br/>
                <div className="row">
                    <div className="col-3">
                        <Button icon="plus"
                                onClick={() => this.setState({modalAdd: true})}>ثبت خدمت</Button>
                    </div>
                </div>

                <br/>
                <div className="list">
                    {services.map((s, i) =>
                        <article key={"service" + i}>
                            <div className="row">
                                <div className="col">
                                    <p className="title"><span>عنوان:</span><span>{s.title}</span></p>
                                    <p className="price"><span>نرخ:</span><span>{s.price}&nbsp;تومان</span></p>
                                </div>
                                <div className="col-auto">
                                    <Icon i="edit" className="edit-icon"
                                          onClick={() => this.setState({editIndex: i})}/>
                                    <Icon i="trash" className="delete-icon"
                                          onDoubleClick={() => this.delete(s.id)}/>
                                </div>
                            </div>
                        </article>
                    )}
                </div>
            </div>
        );
    }
}

export default gpn(Services);